import { Directive, ElementRef, HostListener, inject, input } from '@angular/core';;

@Directive({
  selector: '[upperCase]',
  standalone: true
})
export class UpperCase2Directive {
  upperCase = input(false);

  readonly #input = inject(ElementRef<HTMLInputElement>);

  @HostListener('input')
  onInput(): void {
    if (!this.upperCase()) return;

    const nativeInput = this.#input.nativeElement;
    const value = nativeInput.value;
    const upperValue = value.toUpperCase();

    // Si no hay cambios, no hacer nada
    if (value === upperValue) return;

    // GUARDAMOS la posición del cursor
    const start = nativeInput.selectionStart ?? value.length;
    const end = nativeInput.selectionEnd ?? value.length;

    // Asignamos el nuevo valor
    nativeInput.value = upperValue;

    // RESTAURAMOS la posición del cursor
    nativeInput.setSelectionRange(start, end);

    // Notificamos a Angular correctamente
    nativeInput.dispatchEvent(
      new Event('input', { bubbles: true })
    );
  }
}
